import AT from '../constants/action-types';

// One provider per session. Only the super admin has `all` — the providers it
// can switch between (app-init-saga, right-menu).
const initialState = {
  myProvider: null,
  myUsers: null,
  all: null
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function app(state = initialState, action: any = {}) {
  switch (action.type) {
    case AT.FETCH_SERVICE_PROVIDER_DONE:
      return { ...state, myProvider: action.data };
    case AT.FETCH_SERVICE_PROVIDERS_DONE:
      return { ...state, all: action.data.items };
    case AT.FETCH_SERVICE_PROVIDER_USERS_DONE: {
      return { ...state, myUsers: action.data.items };
    }
    default:
      return state;
  }
}
